export default __webpack_public_path__ + "static/media/bg-together-mobile.77eacf35.png";